<template>
  <li
    class="dropdown-header"
    role="separator"
  >
    {{ text }}
  </li>
</template>

<script>
export default {
  name: 'DpDropdownHeader',

  props: {
    text: {
      type: String,
      required: true,
      default: null,
    },
  },
};
</script>
